import { LIMIT_REPONSE_FAILURE, LIMIT_REPONSE_REQUEST, LIMIT_REPONSE_SUCCESS } from "../Types";

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const LimitReponseReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIMIT_REPONSE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case LIMIT_REPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
      };

    case LIMIT_REPONSE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default LimitReponseReducer;
